import { render } from "./DetallesAlumnoView.vue?vue&type=template&id=56d50dde&scoped=true"
import script from "./DetallesAlumnoView.vue?vue&type=script&lang=js"
export * from "./DetallesAlumnoView.vue?vue&type=script&lang=js"

import "./DetallesAlumnoView.vue?vue&type=style&index=0&id=56d50dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d50dde"]])

export default __exports__